import styled from "styled-components";

export const ResetPasswordModalWrapper = styled("div")(() => {
  return {
    overflow: "hidden",
    padding: "var(--cardPadding)",
    "& form": {
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      gap: "calc(var(--flexGap))",
      "& legend": {
        fontFamily: "Inter",
        fontWeight: 500,
        fontSize: "24px",
        textAlign: "center",
        marginBlock: "0 calc(var(--sectionMargin)/1.5)",
        paddingInline: 0,
      },
      "& label": {
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: "0.8rem",
        color: "var(--color-primary)",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        display: "inline-block",
        marginBottom: "0.5rem",
      },
      "& input": {
        padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) / 2)",
        borderRadius: "0.45rem",
        border: "1px solid var(--color-primary-hover)",
        fontWeight: "400",
        color: "var(--color-text)",
        backgroundColor: "var(--color-button-secondary)",
        "&:focus": {
          border: "1px solid var(--color-primary-hover)",
          outline: "none",
        },
      },
      "@media screen and (min-width: 612px)": {
        "& legend": {
          fontSize: "32px",
        },
      },
    },
    "@media screen and (max-width: 425px)": {
      padding: "calc(var(--cardPadding)/2)",
    },
  };
});
